export default function (cell, formatterParams, onRendered) {
    const value = cell.getValue();
    const orderedIcon = '<i class="fa fa-fw fa-check-circle text-success pe-2" title="Ordered"></i>';
    const quotedIcon = '<i class="fa fa-fw fa-times-circle text-warning-emphasis pe-2" title="Quoted"></i>';

    if (!value || (Array.isArray(value) && value.length === 0)) {
        return '';
    }

    const el = document.createElement('div');
    el.classList.add('d-flex', 'flex-column', 'align-items-center');

    let html = `<div>
    ${value.map((value) => value.includes('Order') ? orderedIcon : '').join('')}
    ${value.map((value) => value.includes('Quote') ? quotedIcon : '').join('')}
  </div>`;

    el.innerHTML = html;
    return el;
}
